/**
 * @file     submissionId.ts
 * @readme   ./README.md
 * @purpose  Creates one stable UUID for every lead-flow journey so retries and quick-to-detailed upgrades update the same lead record.
 */

export function createLeadFlowSubmissionId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    return (char === 'x' ? random : (random & 0x3) | 0x8).toString(16);
  });
}
